import {Activite} from "../activite/activite.model";
import {Centre} from "../centre/centre.model";
import {Enseignant} from "../enseignant/enseignant.model";
import {Niveau} from "../niveau/niveau.model";
import {Subscription} from "../subscription/subscription.model";
import {AttachmentModel} from "@Common/widgets/general/attachments/interfaces/attachment.model";
import {Campagne} from "app/suaps/common/services/campagne/campagne.model";

export interface Planning {
  id?: number;
  libelle?: string;
  jour?: DayEnum;
  jour_label?: string;
  type_cours?: TypeCours;
  type_cours_label?: string;
  heure_debut?: string;
  heure_fin?: string;
  places_disponibles?: number;
  is_active?: boolean;
  is_locked?: boolean;
  date_debut_stage?: string;
  date_fin_stage?: string;
  niveau?: number;
  niveau_obj?: Niveau;
  activite?: number;
  activite_obj?: Activite;
  centre?: number;
  centre_obj?: Centre;
  enseignant?: number;
  enseignant_obj?: Enseignant;
  campagne?: number;
  subscriptions: string[];
  subscriptions_count?: number;
  subscriptions_obj: Subscription[];
  categorie_cours?: PlanningCategorieCours;
  categorie_cours_label?: string;
  count_waiting?: number;
  count_accepted?: number;
  count_refused?: number;
  attachments_obj?: AttachmentModel[];
  content_type?: number;
  campagne_obj?: Campagne;
}

export enum DayEnum {
  monday = 1,
  tuesday = 2,
  wednesday = 3,
  thursday = 4,
  friday = 5,
  saturday = 6,
  sunday = 7,
  freeAccess = 101
}

export interface Day {
  id?: number;
  label?: string;
}

export enum TypeCours {
  cours = 1,
  stage = 2,
}

export enum PlanningCategorieCours {
  ec_libre = 1,
  loisir = 2,
  les_deux = 3,
}

export interface MailBombingDest {
  accepted: boolean;
  waiting: boolean;
  refused: boolean;
}

export interface MailBombing {
  planningId: number;
  destinataires: MailBombingDest;
  description: string;
  rawDescription: string;
}
